import { IAppState } from '../../redux';

export function selectActivePackageId(state: IAppState): string | null {
  return state.publishTerms.selectedPackageId;
}
